
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Regular","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"cls-1",attrs:{"cx":"7.5","cy":"7.875","r":"4.125"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M.75 20.25a6.75 6.75 0 0113.5 0"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"17.727","cy":"10.125","r":"3.375"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M15.813 15.068a5.526 5.526 0 017.437 5.182"}})])
          )
        }
      }
    